document.addEventListener('DOMContentLoaded', function() {
  let isCustomized = false;
  
  // Cookie設定を取得（デフォルト値付き）
  function getCookieSettings() {
    if (window.cookieSettings) {
      return window.cookieSettings;
    }
    // フォールバック用のデフォルト値
    return {
      bodyText: '当サイトでは、お客様の利便性向上やサイトの改善、マーケティングのためにCookieを使用しています。「同意する」をクリックすると、Cookieの使用に同意したことになります。<br>詳細は <a id="shopify-pc__banner__body-policy-link" href="{POLICY_URL}" target="_blank" rel="noopener noreferrer">Cookie policy</a> をご覧ください。',
      acceptButtonText: '同意する',
      declineButtonText: '同意しない',
      policyUrlJa: '/pages/cookie-policy',
      policyUrlEn: '/en/pages/cookie-policy',
      currentLanguage: 'ja'
    };
  }
  
  // Cookie Policy URLを動的に設定
  function getCookiePolicyUrl() {
    const settings = getCookieSettings();
    const isEnglish = window.location.pathname.startsWith('/en') || settings.currentLanguage === 'en';
    return window.location.origin + (isEnglish ? settings.policyUrlEn : settings.policyUrlJa);
  }
  
  // クッキーバナーのテキストをカスタマイズ
  function customizeCookieBanner() {
    if (isCustomized) {
      return; // すでにカスタマイズ済みの場合は何もしない
    }
    
    const cookieBanner = document.getElementById('shopify-pc__banner');
    
    if (cookieBanner) {
      const settings = getCookieSettings();
      const bodyText = cookieBanner.querySelector('.shopify-pc__banner__body p');
      
      if (bodyText && !bodyText.dataset.customized) {
        // テンプレート内のプレースホルダーを実際のURLに置換
        const cookiePolicyUrl = getCookiePolicyUrl();
        const customBodyText = settings.bodyText.replace('{POLICY_URL}', cookiePolicyUrl);
        bodyText.innerHTML = customBodyText;
        bodyText.dataset.customized = 'true';
      }
      
      const acceptBtn = cookieBanner.querySelector('#shopify-pc__banner__btn-accept');
      
      if (acceptBtn && !acceptBtn.dataset.customized) {
        acceptBtn.textContent = settings.acceptButtonText;
        acceptBtn.dataset.customized = 'true';
      }
      
      const declineBtn = cookieBanner.querySelector('#shopify-pc__banner__btn-decline');
      
      if (declineBtn && !declineBtn.dataset.customized) {
        declineBtn.textContent = settings.declineButtonText;
        declineBtn.dataset.customized = 'true';
      }
      
      if (bodyText && acceptBtn && declineBtn) {
        isCustomized = true;
      }
    }
  }
  
  // 初回実行
  customizeCookieBanner();
  
  // より効率的な監視 - 特定の要素のみを監視
  let attemptCount = 0;
  const maxAttempts = 10;
  
  const checkInterval = setInterval(function() {
    if (isCustomized || attemptCount >= maxAttempts) {
      clearInterval(checkInterval);
      return;
    }
    
    customizeCookieBanner();
    attemptCount++;
  }, 500); // 0.5秒ごとにチェック
});